import { makeAutoObservable, runInAction } from 'mobx';
import { toast } from 'react-toastify';
import agent from '../api/agent';
import { Department } from '../models/department';

export default class DepartmentStore {
  departmentRegistry = new Map<string, Department>();
  selectedDepartment: Department | undefined = undefined;
  loadingInitial = false;
  loading = false;
  departmentsListByCustomerName: string[] = [];
  createUserDepartmentList: { key: string; text: string; value: string }[] = [];

  constructor() {
    makeAutoObservable(this);
  }
  get departmentitemsByDate() {
    return Array.from(this.departmentRegistry.values());
  }
  setLoadingInitial = (state: boolean) => {
    this.loadingInitial = state;
  };

  getDepartmentsByCustomer = async (customer: string) => {
    try {
      const params = {
        customer,
      };
      const departments =
        await agent.Departments.getDepartmentByCustomer(params);
      runInAction(() => {
        this.departmentsListByCustomerName = departments.data;
        this.createUserDepartmentList.push(
          ...this.departmentsListByCustomerName?.map((x: string) => ({
            key: x,
            text: x,
            value: x,
          })),
        );
      });
    } catch (error) {
      toast.error('Department List not retrived, please try again.');
    }
  };

  loadDepartments = async () => {
    this.loadingInitial = true;
    try {
      const departmentdetail = await agent.Departments.list();
      // console.log(recievingdelivery);
      departmentdetail.forEach((departmentdetail) => {
        runInAction(() => {
          this.setDepartment(departmentdetail);
        });
      });
      this.setLoadingInitial(false);
    } catch (error) {
      runInAction(() => {
        console.log(error);
        this.setLoadingInitial(false);
      });
    }
  };

  loadDepartment = async (id: string) => {
    this.loadingInitial = true;
    try {
      const departmentdetail = await agent.Departments.details(id);
      this.setDepartment(departmentdetail);
      runInAction(() => {
        this.selectedDepartment = departmentdetail;
      });
      this.setLoadingInitial(false);
      return departmentdetail;
    } catch (error) {
      console.log(error);
      this.setLoadingInitial(false);
    }
  };
  private setDepartment = (Department: Department) => {
    this.departmentRegistry.set(Department.id, Department);
  };

  createDepartment = async (department: Department) => {
    this.loading = true;
    try {
      await agent.Departments.create(department);
      runInAction(() => {
        this.departmentRegistry.set(department.id, department);
        this.selectedDepartment = department;
        //this.editMode = false;
        this.loading = false;
      });
      toast.success('Department Created Successfully');
    } catch (error) {
      console.log(error);
      runInAction(() => {
        this.loading = false;
      });
    }
  };
  updateDepartment = async (department: Department) => {
    this.loading = true;

    try {
      await agent.Departments.update(department);
      runInAction(() => {
        this.departmentRegistry.set(department.id, department);
        this.selectedDepartment = department;
        // this.editMode = false;
        this.loading = false;
      });
      toast.success('Updated succesfully');
    } catch (error) {
      console.log(error);
      runInAction(() => {
        this.loading = false;
      });
    }
  };
  deleteDepartment = async (Department: Department) => {
    try {
      await agent.Departments.delete(Department);
      runInAction(() => {
        this.departmentRegistry.delete(Department.id);
      });
      toast.success('Department Deleted Succesfully');
    } catch (error) {
      runInAction(() => {
        console.log(error);
      });
    }
  };
}
